import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import Logo from "images/integria-logo-dark.png";

export default function SiteMigrated() {
  const history = useHistory();

  useEffect(() => {
    document.documentElement.style.setProperty("--body-bg-color", "white");
  }, []);

  const handleGoHome = () => {
    history.push("/");
  };

  return (
    <div className="bg-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 mb-24">
        <div className="text-center py-20">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Site Updated
          </h1>
          <p className="text-lg text-gray-600 mb-6">
            We've updated our portal! The link you followed is from our old
            system.
          </p>

          <div className="max-w-2xl mx-auto mb-8">
            <div className="bg-gray-50 rounded-lg p-6 mb-4">
              <h2 className="text-lg font-semibold text-gray-900 mb-2">
                For Practitioners
              </h2>
              <p className="text-base text-gray-600 mb-4">
                Please update your bookmarks and saved links to use the new
                portal.
              </p>
              <button
                onClick={handleGoHome}
                className="bg-integria-green text-white px-6 py-3 rounded-lg font-medium hover:bg-integria-green/90 transition-colors"
              >
                Go Home
              </button>
            </div>

            <div className="bg-gray-50 rounded-lg p-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-2">
                For Patients
              </h2>
              <p className="text-base text-gray-600">
                Please contact your prescribing practitioner.
                <br />
                They will provide you with a link to your prescription.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
